export class Bytes {
    constructor(base64) {
        this.base64 = base64;
    }
    static fromBase64String(base64) {
        return new Bytes(base64);
    }
    static fromUint8Array(array) {
        const chunkSize = 0x8000;
        const chunks = [];
        for (let i = 0; i < array.byteLength; i += chunkSize) {
            const chunk = array.subarray(i, i + chunkSize);
            chunks.push(String.fromCharCode.apply(null, chunk));
        }
        return new Bytes(btoa(chunks.join('')));
    }
    toBase64() {
        return this.base64;
    }
    toUint8Array() {
        const binary = atob(this.base64);
        const array = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            array[i] = binary.charCodeAt(i);
        }
        return array;
    }
    toJSON() {
        return {
            __type__: 'bytes',
            bytes: this.base64,
        };
    }
}
//# sourceMappingURL=bytes.js.map